import clsx from "clsx";

export default function Tag({ label, image, color, active, onClick,className="" }) {

    const tagColor = color ? color : "rgb(110,165,173)";

    //Style du tag si actif
    const styleActive = {
        backgroundColor: tagColor,
        boxShadow: "inset 0 0 0 2px " + tagColor
    };

    //Style du tag si inactif
    const styleInactive = {
        boxShadow: "inset 0 0 0 2px " + tagColor
    };

    return (
        <div className={clsx(className,"flex flex-row items-center rounded-full p-1 cursor-pointer px-2")} style={active ? styleActive : styleInactive} onClick={onClick}>
            <img className={image?"size-5 mr-1":"hidden"} src={image} alt=""></img>
            <p className="text-md font-medium text-dark-green">{label}</p>
        </div>
    )
}